/* eslint-disable */
import axios from 'axios/dist/axios';
import authService from '@services/auth.service';
import tokenProvider from 'axios-token-interceptor';
import AzureInstance from '../services/AzureInstance';
import swal from 'sweetalert';

import ms from 'ms';

let VueAxiosPlugin = {};

let defaultOptions = {
  baseURL: process.env.VUE_APP_apiBaseUrl,
  crossDomain: true,
  headers: {},

  // request interceptor handler
  reqHandleFunc: config => config,
  reqErrorFunc: error => Promise.reject(error),

  // response interceptor handler
  resHandleFunc: response => response,
  resErrorFunc: error => Promise.reject(error)
};

const tokenCache = tokenProvider.tokenCache(
  () => authService.getToken().then(res => res),
  {
    maxAge: ms('8h')
  }
);

const axiosInstance = axios.create(defaultOptions);

// Add a request interceptor
axiosInstance.interceptors.request.use(
  tokenProvider({
    getToken: tokenCache
  }),
  config => defaultOptions.resHandleFunc(config),
  error => defaultOptions.reqErrorFunc(error)
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
  response => defaultOptions.resHandleFunc(response),
  error => defaultOptions.resErrorFunc(error)
);
axiosInstance.interceptors.response.use((response) => {
    return response;
  }, 
  function (error) {
    if (error.response && error.response.status === 401) {
      swal({  title: 'Error', icon: 'error', text: 'You are not authorized to see this page or your session has expired. Please login again.',  
        buttons: false});
      setTimeout(() => {
        AzureInstance.logout();
      }, 5000);
    }
    throw error;
})

VueAxiosPlugin.install = (Vue, options) => {
  Vue.prototype.$axios = axiosInstance;

  Vue.prototype.$http = {
    get: (url, data, options) => {
      let axiosOpt = {
        ...options,
        ...{
          method: 'get',
          url: url,
          params: data
        }
      };
      return axiosInstance(axiosOpt);
    },
    post: (url, data, options) => {
      let axiosOpt = {
        ...options,
        ...{
          method: 'post',
          url: url,
          data: data
        }
      };
      return axiosInstance(axiosOpt);
    }
  };
};

//export default VueAxiosPlugin;

export default axiosInstance;
